import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, Button, DialogActions } from '@material-ui/core';
import { OptionType } from '../EmployeesComboboxMI';
import lang from "./RelationsLang";

interface IProps {
	warningEmployeeChange: OptionType,
	onAccept: () => void,
	onCancel: () => void,
}

export default function WarningEmployeeChange(props: IProps) {
	return <Dialog
		open={props.warningEmployeeChange != null}
		onClose={props.onCancel}
	>
		{props.warningEmployeeChange != null && <>
			<DialogTitle>{lang.warningEmployeeChangeTitle()}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<span dangerouslySetInnerHTML={{ __html: lang.format("warningEmployeeChangeText", ['<strong>' + props.warningEmployeeChange.label + '</strong>']) }} ></span>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onCancel} color="default">
					{lang.get("cancel")}
				</Button>
				<Button onClick={props.onAccept} color="primary" variant="contained" autoFocus>
					{lang.get("ok")}
				</Button>
			</DialogActions>
		</>}
	</Dialog>
}